import { format, formatDuration, intervalToDuration } from "date-fns";

/** ISO-style dates in tables (e.g. 2026-06-28). */
export function formatTableDate(value: Date | string): string {
  const date = typeof value === "string" ? new Date(value) : value;
  return format(date, "yyyy-MM-dd");
}

/** English-locale money display (AUD), always two decimal places. */
export function formatMoney(
  value: number,
  options?: { currency?: string },
): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: options?.currency ?? "AUD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function currency(value: string | number, digits: number = 0) {
  const formatter = new Intl.NumberFormat("en-au", {
    style: "currency",
    currency: "aud",
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
  const v: number = value ? parseFloat(value.toString()) : 0;
  return formatter.format(v);
}

/** Elapsed time from `start` to `end` as years, months, and days (calendar-based). */
export function formatElapsedYmd(
  start: Date | string,
  end: Date = new Date(),
): string {
  const startDate = typeof start === "string" ? new Date(start) : start;
  const duration = intervalToDuration({ start: startDate, end });
  const formatted = formatDuration(duration, {
    format: ["years", "months", "days"],
    delimiter: ", ",
  });
  return formatted || "Less than a day";
}
